import api from "src/apis/api";

export const fetchContacts = async (params) => {
  const { data } = await api.get("/api/v1/contacts", { params });
  return data; // { contacts: [...], meta: {...} }
};

export const createContact = async (payload) => {
  const { data } = await api.post("/api/v1/contacts", { contact: payload });
  return data;
};

export const updateContact = async (id, payload) => {
  const { data } = await api.patch(`/api/v1/contacts/${id}`, { contact: payload });
  return data;
};

export const deleteContact = async (id) => {
  const { data } = await api.delete(`/api/v1/contacts/${id}`);
  return data;
};
